import { Box, CircularProgress, Container } from '@mui/material';
import React, { Component } from 'react'
import Constantes from '../php/Constantes';

class UsuarioAsociado extends Component {
    constructor(props){
        super(props);
        this.state = {
            notificaciones: null,
            errores: null,
            loading: false,
            cambio: {
                usuario: '',
                usuarioConfirmado: '',
                numeroFuncionario: '',
                numeroFuncionarioConfirmado: '',
            },
        }
        this.controlarCambios = this.controlarCambios.bind(this);
        this.manejarEnvioCambio = this.manejarEnvioCambio.bind(this);
    }

    async componentDidMount(){

    }

    render(){
        return (
            <>
                <Container>
                    <h3>Modificar Usuario Asociado</h3>
                    {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                    {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                    {this.state.loading
                    ?
                        <div style={{placeItems: 'center'}}>
                            <Box sx={{alignItems: 'center'}}>
                                <CircularProgress/>
                            </Box>
                        </div>
                    :
                        null
                    }
                    <div className='mt-5'>
                        <hr />
                        <div className='row justify-content-center'>
                            <div className="col-12 col-sm-8 col-md-6 col-xl-4">
                                <form onSubmit={this.manejarEnvioDatos}>
                                    <input type="text" className='form-control mb-2' placeholder='INGRESE EL USUARIO' id='usuario' onChange={this.controlarCambios} value={this.state.cambio.usuario}/>
                                    <input type="text" className='form-control mb-2' placeholder='CONFIRMAR USUARIO' id='usuarioConfirmado' onChange={this.controlarCambios} value={this.state.cambio.usuarioConfirmado}/>
                                    <input type="text" className='form-control mb-2' placeholder='INGRESE NUMERO FUNCIONARIO ASOCIADO' id='numeroFuncionario' onChange={this.controlarCambios} value={this.state.cambio.numeroFuncionario}/>
                                    <input type="text" className='form-control mb-2' placeholder='CONFIRMAR NUMERO FUNCIONARIO ASOCIADO' id='numeroFuncionarioConfirmado' onChange={this.controlarCambios} value={this.state.cambio.numeroFuncionarioConfirmado}/>
                                    <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioCambio}>Confirmar</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </Container>
            </>
        )
    }

    controlarCambios(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
        })
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const registroActualizado = state.cambio;
            registroActualizado[clave] = valor;
            return{
                cambio: registroActualizado,
            };
        })
    }

    async manejarEnvioCambio(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
        })
        if((this.state.cambio.usuario === '') || (this.state.cambio.usuarioConfirmado === '') || (this.state.cambio.numeroFuncionario === '') || (this.state.cambio.numeroFuncionarioConfirmado === '')){
            this.setState({
                errores: 'Todos los campos son obligatorios',
            })
        }else if((this.state.cambio.usuario !== this.state.cambio.usuarioConfirmado)){
            this.setState({
                errores: 'Los nombres de usuarios tienen que ser iguales',
            })
        }else if((this.state.cambio.numeroFuncionario !== this.state.cambio.numeroFuncionarioConfirmado)){
            this.setState({
                errores: 'Los números de funcionario tienen que ser iguales',
            })
        }else{
            const cargaUtil = JSON.stringify([this.state.cambio, sessionStorage.numeroFuncionarioAsociado]);

            const respuesta = await fetch(`${Constantes.RUTA_API}/modificar_usuarioAsociado.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();

            if(exito[0] === 'ok'){
                this.setState({
                    errores: null,
                    notificaciones: 'El funcionario fue asociado correctamente',
                    cambio: {
                        usuario: '',
                        usuarioConfirmado: '',
                        numeroFuncionario: '',
                        numeroFuncionarioConfirmado: '',
                    },
                })
            }
        }
    }
}

export default UsuarioAsociado